import { __assign, __read, __spreadArray } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import { Box, Checkbox, FormControl, FormControlLabel, Typography } from "@material-ui/core";
import cn from "classnames";
export var MultipleCheckbox = function (_a) {
    var className = _a.className, selectOptions = _a.selectOptions, otherInputProps = _a.otherInputProps, readonly = _a.readonly, values = _a.values, onChange = _a.onChange;
    var _b = __read(useState(__spreadArray([], __read(values), false)), 2), selectedIds = _b[0], setSelectedIds = _b[1];
    var initialRender = useRef(true);
    useEffect(function () {
        if (selectedIds.length !== values.length) {
            setSelectedIds(values);
        }
    }, [values]);
    useEffect(function () {
        if (initialRender.current) {
            initialRender.current = false;
        }
        else {
            onChange(selectedIds);
        }
    }, [selectedIds]);
    return (React.createElement(Box, { className: className },
        React.createElement(FormControl, { size: "small", variant: "filled", fullWidth: true }, selectOptions.map(function (item) { return (React.createElement(FormControlLabel, __assign({ key: "".concat(item.value), control: React.createElement(Checkbox, __assign({}, otherInputProps, { color: "primary", checked: selectedIds.includes(item.value), disabled: item.disabled, onChange: function (e) {
                    if (e.target.checked) {
                        setSelectedIds(function (prevValue) { return __spreadArray(__spreadArray([], __read(prevValue), false), [item.value], false); });
                    }
                    else {
                        setSelectedIds(function (prevValue) { return __spreadArray([], __read(prevValue.filter(function (v) { return v !== item.value; })), false); });
                    }
                } })), label: React.createElement(Typography, { className: cn({
                    disabled: item.disabled
                }) }, item.text) }, (readonly ? { readonly: true } : {})))); }))));
};
//# sourceMappingURL=MultipleCheckbox.js.map